export default __webpack_public_path__ + "static/pk-af7f6f40f6194466b0c73b1db3f954c9.svg";